import type { DataverseTool } from "@p0security/shared/integrations/resources/copilot-studio/types";
import { Descriptions } from "antd";

export const CopilotStudioConnectorDetails: React.FC<{
  tool: DataverseTool;
}> = ({ tool }) => (
  <Descriptions
    data-testid="copilot-studio-connector-details"
    column={1}
    size="small"
    bordered
  >
    <Descriptions.Item label="Display Name">
      {tool.displayName}
    </Descriptions.Item>
    <Descriptions.Item label="Connector ID">
      {tool.connectorid ?? "\u2014"}
    </Descriptions.Item>
    <Descriptions.Item label="Agent">{tool.agentId}</Descriptions.Item>
  </Descriptions>
);
